import React, { useState } from 'react';
import ProductInfoModal from './ProductInfoModal';
import { isProductInfoEnabled } from '@/services/productInfo';

// "Learn more" text link shown next to the medication name on the product /
// treatment step. Clicking it opens ProductInfoModal (AI About/Common-uses +
// live Q&A chat), matching the patient-dashboard shop. Self-contained so a
// checkout step only needs one line: <ProductLearnMore product={active} />.
//
// Renders nothing when the feature is dark (REACT_APP_PRODUCT_INFO_ENABLED not
// 'true') or when the catalog item has no medId (the modal is keyed on medId).

const ProductLearnMore = ({ product, className = '' }) => {
  const [open, setOpen] = useState(false);

  const medId = product?.medId;
  if (!isProductInfoEnabled() || !medId) return null;

  const modalProduct = {
    medId,
    name: product.name || product.medication,
    strength: product.strength,
    dose: product.dose,
    visitType: product.visitType,
  };

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        data-testid="learn-more-link"
        className={`text-sm text-[#2d8a5f] underline underline-offset-2 hover:text-[#236b4a] ${className}`}
      >
        Learn more
      </button>
      <ProductInfoModal
        product={modalProduct}
        open={open}
        onClose={() => setOpen(false)}
      />
    </>
  );
};

export default ProductLearnMore;
